"use client";

import type { ReactNode } from "react";
import { Reveal } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

interface CharityGlassPanelProps {
  children: ReactNode;
  className?: string;
  reveal?: boolean;
  revealDelay?: number;
}

export function CharityGlassPanel({
  children,
  className,
  reveal = true,
  revealDelay = 0,
}: CharityGlassPanelProps) {
  const panel = (
    <div
      className={cn(
        "charity-glass-panel relative overflow-hidden rounded-3xl border p-6 shadow-[0_12px_40px_rgba(26,77,46,0.1)] backdrop-blur-[20px] md:p-8",
        "border-[var(--charity-green)]/15 bg-white/70",
        "dark:border-white/10 dark:bg-white/5 dark:shadow-[0_12px_40px_rgba(0,0,0,0.3)]",
        className
      )}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-3xl bg-gradient-to-br from-white/60 via-transparent to-[var(--charity-green)]/[0.04] dark:from-white/5 dark:to-transparent"
        aria-hidden
      />
      <div className="relative">{children}</div>
    </div>
  );

  if (!reveal) return panel;

  return (
    <Reveal delay={revealDelay} amount="any">
      {panel}
    </Reveal>
  );
}
